module.exports = __webpack_public_path__ + "static/gdpr-98ea35551734e2af8fd9405dbdaf8c18.svg";